// extracted by mini-css-extract-plugin
export default {"container":"logo_container__dvij6","dark_container":"logo_dark_container__-O1Hc","dark_logo":"logo_dark_logo__Cmh2x"};